import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Image } from '@thd-olt-component-react/core-ui';
import { Card } from '@thd-olt-component-react/card';
import { Heading } from '@thd-olt-component-react/heading';
import { track } from './related-search-analytics';

const RelatedSearchLinks = (props) => {
  const {
    relatedLinks,
    title
  } = props;

  const {
    channel
  } = useContext(ExperienceContext);

  const renderRelatedSearch = (relatedSearchResults) => {
    let url = '';

    return (
      <div className="related-search__links">
        {relatedSearchResults.map((relatedSearchResult, index) => {
          url = relatedSearchResult.url || (`/s/${encodeURIComponent(relatedSearchResult.keyword)}`);
          const copyText = relatedSearchResult.anchor || relatedSearchResult.keyword;

          return (
            <span className="related-search__elements" key={`relatedSearchResult-${copyText}${index}`}>
              <Image
                src="https://assets.thdstatic.com/images/v1/magnify-tilted-left-grey.svg"
                alt="magnifying glass"
                className="related-search__elements__magnify-symbol"
                height="14"
                width="14"
              />
              <a className="bttn--inline" href={url} onClick={() => track(copyText)}>
                <h3 className="related-search__elements-text">{copyText}</h3>
              </a>
            </span>
          );
        })}
      </div>
    );
  };

  return (
    <Row className="related-search">
      <Col>
        {channel !== 'mobile'
          && (
            <>
              <Heading centered underline title={title} />
              {renderRelatedSearch(relatedLinks)}
            </>
          )}
        {channel === 'mobile'
          && (

            <>
              <Heading underline title={title} />
              {renderRelatedSearch(relatedLinks)}
            </>

          )}
      </Col>
    </Row>
  );
};

export { RelatedSearchLinks };

RelatedSearchLinks.propTypes = {
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      anchor: PropTypes.string,
      url: PropTypes.string
    })
  ).isRequired,
  title: PropTypes.string
};

RelatedSearchLinks.defaultProps = {
  title: 'Related Searches'
};
